/**
 * A place to store fixed global references.
 * This is useful for storing fixed references, so we can access them from anywhere.
 * There's no proxy here, so we can't subscribe to changes and mutation is not tracked.
 * These references should be set once and never changed.
 */
import * as Pioneer from 'pioneer';

const globalRefs = {
  datasetId: null,
  lightColorOn: new Pioneer.Color(1, 1, 1),
  lightColorOff: new Pioneer.Color(0, 0, 0),
  getManager: null,
  pioneer: null,
  router: null,
  setQuery: null,
  nextAutoplaySlideTimeout: null,
  autoplayCommandTimeout: null,
  notFirstPage: false
};

const setGlobalRef = (refName, ref) => {
	if (globalRefs[refName] === undefined) {
		console.warn(`Reference ${refName} is not defined.`);
		return;
	}

	globalRefs[refName] = ref;
};

export default globalRefs;

export { setGlobalRef };
